import { Box, IBoxProps } from 'native-base';
import { isBehindPace } from '../_helper';

type ProgressBarProps = IBoxProps & {
  actual?: number;
  elapsedForecast?: number;
  fullForecast?: number;
};

// Custom progress bar with pace notch
export const ProgressBar = ({ actual = 0, elapsedForecast = 0, fullForecast = 0, ...props }: ProgressBarProps) => {
  const behind = isBehindPace(actual, elapsedForecast);

  const fillPct = fullForecast > 0 ? Math.min((actual / fullForecast) * 100, 100) : 0;
  const notchPctRaw = fullForecast > 0 ? (elapsedForecast / fullForecast) * 100 : 0;

  // prevent notch from going outside the bar
  const notchPct = Math.min(notchPctRaw, 99);
  const fillColor = behind ? 'error.500' : 'blueLight.400';

  return (
    <Box rounded="full" w="full" h="5px" justifyContent="center" overflow="hidden" bg="gray.200" {...props}>
      <Box w="full" h="full" position="relative">
        <Box w="full" h="full" overflow="hidden">
          <Box h="full" w={`${fillPct}%`} bg={fillColor} rounded="full" />
        </Box>
        <Box position="absolute" left={`${notchPct}%`} top={0} bottom={0} w="2px" bg="gray.700" rounded="sm" />
      </Box>
    </Box>
  );
};
